// 自定义列信息
export const customColumns = [
  {
    key: 'aggregation_info',
    children: [
      {
        key: 'budget_name',
        isSelected: true,
      },
      {
        key: 'sale_type',
        isSelected: true,
      }
    ],
  },
  {
    key: 'product_info',
    children: [
      // {
      //   key: 'product',
      //   isSelected: true,
      // },
      {
        key: 'product_id',
        isSelected: true,
      },
      {
        key: 'product_name',
        isSelected: true,
      },
      {
        key: 'product_series_name',
        isSelected: true,
      },
      {
        key: 'customer_cate',
        isSelected: true,
      },
    ],
  },

  {
    key: 'task_info',
    children: [
      {
        key: 'task_name',
        isSelected: false,
      },
    ],
  },

  {
    key: 'sale_info',
    children: [
      // {
      //   key: 'direct_sale2',
      //   isSelected: false,
      // },
      // {
      //   key: 'sale',
      //   isSelected: false,
      // },
      {
        key: 'direct_sales_id',
        isSelected: false,
      },
      {
        key: 'direct_sales_name',
        isSelected: false,
      },
      {
        key: 'sale_id',
        isSelected: false,
      },
      {
        key: 'sale_name',
        isSelected: false,
      },
    ],
  },

  {
    key: 'agent_adv',
    children: [
      // {
      //   key: 'agent',
      //   isSelected: false,
      // },
      {
        key: 'agent_id',
        isSelected: false,
      },
      {
        key: 'agent_name',
        isSelected: false,
      },
      {
        key: 'agent_company',
        isSelected: false,
      },

      // {
      //   key: 'account',
      //   isSelected: false,
      // },
      {
        key: 'account_id',
        isSelected: false,
      },
      {
        key: 'account_name',
        isSelected: false,
      },
      {
        key: 'account_company',
        isSelected: false,
      },

      // {
      //   key: 'category',
      //   isSelected: false,
      // },

      {
        key: 'category_one',
        isSelected: false,
      },
      {
        key: 'category_two',
        isSelected: false,
      },
      {
        key: 'category_three',
        isSelected: false,
      },


      {
        key: 'app_marketing_type',
        isSelected: false,
      },
    ],
  },

  {
    key: 'impression_click_cost',
    children: [
      // {
      //   key: 'served_request',
      //   isSelected: true,
      //   isHover: true,
      // },
      {
        key: 'impression_total',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'click_total',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_total',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_cash',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_coupon',
        isSelected: true,
        isHover: true,
      },
    ],
  },

  {
    key: 'good_effect',
    children: [
      {
        key: 'cr',
        isSelected: false,
      },
      {
        key: 'acp',
        isSelected: false,
      },
      {
        key: 'ecpm',
        isSelected: false,
      },
      {
        key: 'list_ctr',
        isSelected: false,
      },
      {
        key: 'detail_ctr',
        isSelected: false,
      },
      {
        key: 'list_acp',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'detail_acp',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'list_ecpm',
        isSelected: false,
      },
      {
        key: 'detail_ecpm',
        isSelected: false,
      },
      {
        key: 'cpa_given',
        isSelected: false,
      },
      {
        key: 'cvr',
        isSelected: false,
      },
      {
        key: 'deep_cvr',
        isSelected: false,
      },
      {
        key: 'cpa',
        isSelected: false,
      },
      {
        key: 'deep_cpa',
        isSelected: false,
      },
      {
        key: 'api_app_active_cost',
        isSelected: false,
      },
      {
        key: 'api_app_register_cost',
        isSelected: false,
      },
      {
        key: 'api_app_lahuo_cost',
        isSelected: false,
      },
      {
        key: 'cvr_keyaction_num',
        isSelected: false,
      },
      {
        key: 'api_app_keyaction_cost',
        isSelected: false,
      },
      {
        key: 'api_app_pay_cost',
        isSelected: false,
      },
      {
        key: 'api_app_retention_active_rate',
        isSelected: false,
      },
      {
        key: 'api_app_retention_register_rate',
        isSelected: false,
      },
      {
        key: 'api_app_retention_lahuo_rate',
        isSelected: false,
      },
    ],
  },

  {
    key: 'plans_and_ideas',
    children: [
      {
        key: 'put_plans_num',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'put_ideas_num',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'new_ideas_num',
        isSelected: false,
        isHover: true,
      },
      // {
      //   key: 'idea_type',
      //   isSelected: false
      // },
      // {
      //   key: 'unit',
      //   isSelected: false
      // },
      // {
      //   key: 'is_ocpc',
      //   isSelected: false
      // }
    ],
  },
];

// 固定显示的表格列
export const fixedColumns = [
  {
    key: 'base_info2',
    children: [
      {
        key: 'date',
      },
      // {
      //   key: 'budget_name',
      // },
      // {
      //   key: 'sale_type',
      // }
    ],
  },
];

// 折线图指标
export const fields = [
  // 'served_request',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_cash',
  'cost_coupon',
];

// 包含涨幅数据的字段
export const fieldWithDiff = [
  // 'served_request',
  'cost_cash',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_coupon',
  'acp',
  'ecpm',
  'list_acp',
  'detail_acp',
  'list_ecpm',
  'detail_ecpm',
  'cpa_given',
  'put_ideas_num',
  'put_plans_num',
  // 'new_ideas_num',
  'cvr', 
  'deep_cvr', 
  'cpa', 
  'deep_cpa',
  'api_app_active_cost',
  'api_app_register_cost',
  'api_app_lahuo_cost',
  'cvr_keyaction_num',
  'api_app_keyaction_cost',
  'api_app_pay_cost',
  'api_app_retention_active_rate',
  'api_app_retention_register_rate',
  'api_app_retention_lahuo_rate',
];
